const getters = {
  token: state => state.user.token,
  // 是否登录
  isLogin: state => state.user.isLogin,
  //  已开通产品
  openedProducts: state => state.user.openedProducts,
  openedStatus: state => state.user.openedStatus,
  // 用户信息
  userInfo: state => state.user.userInfo,
  // 公司信息
  companyInfo: state => state.user.companyInfo,
  //
  hasCompany: state => state.user.hasCompany,

  currentTab: state => state.user.currentTab,
  currentHref: state => state.user.currentHref,
  childName: state => state.user.childName,
  noticeCount: state => state.user.noticeCount,
  language: state => state.user.language
}
export default getters
